import React, { FC, useEffect } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useZoneManager } from './shared/hooks/useZoneManager'
import { useZoneParams } from './shared/hooks/useZoneParams'
import { Errors } from './pages/Errors'
import { useGetProjectQuery } from './modulesCommon/graphql/queries/getProject.types'
import { useZones } from './modulesCommon/serviceHooks/useZones'

export const RedirectWithZonePrefix: FC = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { buildZoneUrl, loading } = useZoneManager()

  useEffect(() => {
    if (!loading) {
      console.info(`Legacy route redirect from ${pathname} to${buildZoneUrl(pathname)}`)
      navigate(buildZoneUrl(pathname))
    }
  }, [buildZoneUrl, loading, pathname, navigate])

  return null
}

export const RedirectProjectToItsZone: FC = () => {
  const { id = '' } = useParams<{ id: string }>()
  const { data } = useGetProjectQuery({ variables: { id } })
  const { getZoneById } = useZones()
  const { buildZoneUrl } = useZoneManager()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  useEffect(() => {
    const zoneId = parseInt(data?.getCampaign?.label_id ?? '')
    if (zoneId) {
      const zone = getZoneById(zoneId)
      if (zone) {
        navigate(buildZoneUrl(pathname, zone))
      }
    }
  }, [buildZoneUrl, data, getZoneById, navigate, pathname])
  return null
}

export const ZoneRouteValidator: FC = (props) => {
  const { zoneAlias, countryCode } = useZoneParams()
  const { isValidZoneAndCountry, loading, currentZone, setZoneLegacy } = useZoneManager()
  useEffect(() => {
    if (currentZone) {
      setZoneLegacy(currentZone.id, countryCode)
    }
  }, [countryCode, currentZone, setZoneLegacy])

  if (loading) return null
  if (isValidZoneAndCountry(zoneAlias, countryCode)) {
    return <Outlet />
  } else {
    // Zone is not found, show to 404
    return <Errors.NotFound />
  }
}
